function Connector2({ name1, name2 }) {
  return (
    <>
      <svg
        width="100%"
        viewBox="0 0 200 68"
        preserveAspectRatio="xMidYMin meet"
        style={{ display: "block" }}
      >
        <line x1="100" y1="0" x2="100" y2="24" stroke="#aaa" strokeWidth="1.5" />
        <polygon points="96,24 100,30 104,24" fill="#aaa" />
        <line x1="50" y1="30" x2="150" y2="30" stroke="#aaa" strokeWidth="1.5" />
        <line x1="50" y1="30" x2="50" y2="60" stroke="#aaa" strokeWidth="1.5" />
        <polygon points="46,60 50,66 54,60" fill="#aaa" />
        <line x1="150" y1="30" x2="150" y2="60" stroke="#aaa" strokeWidth="1.5" />
        <polygon points="146,60 150,66 154,60" fill="#aaa" />
      </svg>
      <div style={{ display: "flex", gap: 4, marginTop: -2 }}>
        <div style={{ flex: 1 }}>
          <input type="text" name={name1} className="text-center" />
        </div>
        <div style={{ flex: 1 }}>
          <input type="text" name={name2} className="text-center" />
        </div>
      </div>
    </>
  );
}

export default Connector2;
